// AdvertisementManagementTab.tsx - Uses AdminAdsPage component
import React from 'react';
import AdminAdsPage from '../../pages/AdminAdsPage';

const AdvertisementManagementTab: React.FC = () => {
  return <AdminAdsPage />;
};

export default AdvertisementManagementTab;